import styled from 'styled-components';
import { TabButton } from 'src/styles/button.style';
import theme from 'src/theme';

export const ReportTypesGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    align-items: start;
    gap: 10px;
`;

export const ReportTypeColumn = styled.div`
    min-width: 0;
`;

// Constrains the "Number of Previous Cargoes" input so its label and value stay close
// together, instead of the label/value spanning the full panel width (the input's
// space-between layout otherwise pushes the value far from its label, especially noticeable
// when read-only/disabled). Also matches the label color to the report checkbox labels for
// visual consistency, and dims + shows a "not-allowed" cursor when disabled, without affecting
// other usages of the shared OdfjellInputComponent.
export const NumberSelectorWrapper = styled.div<{ disabled?: boolean }>`
    max-width: 240px;
    opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};

    .input-value-description {
        color: ${theme.colors.text.blueLink};
    }

    select {
        cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
    }
`;

// Dims an option row and shows a "not-allowed" cursor when its control is disabled - used by the
// Last Cargoes shared options (Manual cargoes only, Include UN No., Include all tanks) for a
// consistent disabled appearance across all of them.
export const OptionOpacityWrapper = styled.div<{ disabled?: boolean }>`
    opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
`;

export const ReportTypeTabButton = styled(TabButton)`
    height: 34px;
    padding: 6px 12px;
    display: flex;
    flex-direction: row;
    align-items: center;
    white-space: nowrap;
    gap: 6px;
`;

export const ReportTypeTabsWrapper = styled.div`
    display: flex;
    align-items: flex-end;
    border-bottom: 1px solid #ddd;
    margin-bottom: 10px;
`;

export const ReportTypeTabBadge = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 16px;
    height: 16px;
    padding: 0 4px;
    border-radius: 8px;
    background-color: ${({ theme }) => theme.colors.text.blueLink};
    color: #fff;
    font-size: 10px;
    font-weight: 600;
    line-height: 1;
`;

export const SelectedReportsStrip = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
    min-height: 22px;
    padding: 10px 0 6px 0;
`;

export const SelectedReportsStripLabel = styled.div`
    width: 100%;
    font-size: 11px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.text.heading};
    text-transform: uppercase;
    letter-spacing: 0.03em;
`;

export const SelectedReportsStripEmptyLabel = styled.span`
    font-size: 12px;
    color: ${({ theme }) => theme.colors.text.lightGrey};
    font-style: italic;
`;

export const SelectedReportChip = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    background-color: ${({ theme }) => theme.colors.background.lightGrey};
    border-radius: 12px;
    padding: 3px 6px 3px 10px;
    font-size: 12px;
`;

export const SelectedReportChipFormatTag = styled.span<{ format: 'pdf' | 'xlsx' }>`
    font-size: 9px;
    font-weight: 700;
    padding: 1px 5px;
    border-radius: 8px;
    color: #fff;
    background-color: ${({ format }) => (format === 'pdf' ? '#c0392b' : '#1e7e34')};
`;

export const SelectedReportChipRemoveButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
    border: none;
    padding: 0;
    margin: 0;
    cursor: pointer;
    color: ${({ theme }) => theme.colors.text.lightGrey};
    font-size: 11px;

    &:hover {
        color: ${({ theme }) => theme.colors.status.errorRed};
    }
`;

export const ConflictBanner = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    background-color: ${({ theme }) => theme.colors.banner.warning.bg};
    border: 1px solid ${({ theme }) => theme.colors.banner.warning.border};
    color: ${({ theme }) => theme.colors.banner.warning.text};
    border-radius: 4px;
    padding: 8px 10px;
    font-size: 12px;
    margin: 4px 0 10px 0;
`;

export const ConflictBannerText = styled.span`
    flex: 1;
`;

export const ConflictBannerButton = styled.button`
    flex-shrink: 0;
    background: none;
    border: 1px solid ${({ theme }) => theme.colors.banner.warning.border};
    color: ${({ theme }) => theme.colors.banner.warning.text};
    border-radius: 4px;
    padding: 4px 10px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;

    &:hover {
        background-color: ${({ theme }) => theme.colors.banner.warning.border};
        color: #fff;
    }
`;

export const SectionDivider = styled.div`
    border: 1px solid #ddd;
    margin: 10px 0;
    height: 1px;
`;

export const OutputActionLabel = styled.label<{ disabled?: boolean }>`
    display: flex;
    align-items: center;
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
    opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
`;

export const OutputActionsContainer = styled.div`
    display: flex;
    gap: 15px;
    justify-content: flex-end;
`;

export const RadioInput = styled.input<{ disabled?: boolean }>`
    margin-right: 5px;
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
`;

export const SelectedCharterersList = styled.div`
    margin-top: 5px;
`;
